import { render } from "./ProductsCardsSlider.vue?vue&type=template&id=2e92d4a6"
import script from "./ProductsCardsSlider.vue?vue&type=script&lang=js"
export * from "./ProductsCardsSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__